<template>
  <section class="kd-card" v-if="ACTIVE_SIDE">
    <div class="kd-card__card" :style="cardStyle">
      <div class="kd-card__inner-card-wrapper" :style="innerCardWrapperStyle">
        <kd-layers></kd-layers>
        <kd-layout
          v-if="LAYOUT_MODE_ACTIVE"
        ></kd-layout>
      </div>
    </div>

    <!-- If there are new webfonts added, they can be displayed in here to have the same size -->
    <!-- <div
      class="kd-font-screenshot-helper"
      style="font-family: Font-Name here; position: fixed; top: 100px; left: 50px; width: 200px; height: 40px; font-size: 16px; border: 1px solid red; padding: 10px; background-color: #EDEDED"
    >
      Font-Name here
    </div> -->

  </section>
</template>

<script>
import { mapGetters } from 'vuex';

import {
  ACTIVE_SIDE,
  LAYOUT_MODE_ACTIVE,
  SCALE,
  IS_PRINT_MODE,
  IS_SCREENSHOT_MODE,
} from '@/store/getter-types';

import KdLayer from '@/components/KdLayer.vue';
import KdLayers from '@/components/KdLayers.vue';
import KdLayout from '@/components/KdLayout.vue';
import { TOP, RIGHT, BOTTOM, LEFT } from '@/shared/directions';

export default {
  computed: {
    ...mapGetters([
      ACTIVE_SIDE,
      LAYOUT_MODE_ACTIVE,
      SCALE,
      IS_SCREENSHOT_MODE,
      IS_PRINT_MODE,
    ]),
    cardStyle() {
      return {
        width: `${this.ACTIVE_SIDE.printWidth}mm`,
        height: `${this.ACTIVE_SIDE.printHeight}mm`,
        // TODO: Implement auto-scaling, based on card with/height and window size
        transform: `scale(${this.SCALE})`,
      };
    },
    innerCardWrapperStyle() {
      const pdfSpecificStyles = {};
      if (this.IS_PRINT_MODE && !this.IS_SCREENSHOT_MODE) {
        if (this.ACTIVE_SIDE.shifts) {
          if (this.ACTIVE_SIDE.shifts[TOP]) {
            pdfSpecificStyles.top = `${-this.ACTIVE_SIDE.shifts[TOP]}mm`;
          }
          if (this.ACTIVE_SIDE.shifts[BOTTOM]) {
            pdfSpecificStyles.bottom = `${-this.ACTIVE_SIDE.shifts[BOTTOM]}mm`;
          }
          if (this.ACTIVE_SIDE.shifts[LEFT]) {
            pdfSpecificStyles.left = `${-this.ACTIVE_SIDE.shifts[LEFT]}mm`;
          }
          if (this.ACTIVE_SIDE.shifts[RIGHT]) {
            pdfSpecificStyles.right = `${-this.ACTIVE_SIDE.shifts[RIGHT]}mm`;
          }
        }
      }
      return {
        ...pdfSpecificStyles,
      };
    },
  },
  components: {
    KdLayer,
    KdLayers,
    KdLayout,
  },
};
</script>

<style lang="scss">
  .kd-card {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .kd-card__inner-card-wrapper {
    position: relative;
    width: 100%;
    height: 100%;
    overflow: hidden;
  }

  .kd-card__card {
    position: relative;
    // TODO: This value might be needed elsewhere, e.g. when the card is auto-scaled
    // makes sure, that the thumbnails (side-switcher) does not overlay the card easily
    top: -60px;
    // background-color: #999;

    .kd--print:not(.kd--screenshot) & {
      // In print mode we need to correct the offset caused by the Puppeteer footer
      // (margin-top, margin-bottom) and non-existing header-template.
      // See index.js of kartendesigner-services
      // To make sure this value is correct the final PDF needs to be opened in e.g. Illustrator
      // and checked if the card is centered on the PDF side or not.
      //
      // In screenshot mode the card must not use this rule, otherwise the screenshot does
      // not contain the hole card.
      top: 190px !important;
    }
  }
</style>
